import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=e9061caa&scoped=true"
import script from "./infoBox.vue?vue&type=script&lang=js"
export * from "./infoBox.vue?vue&type=script&lang=js"
import style0 from "./infoBox.vue?vue&type=style&index=0&id=e9061caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9061caa",
  null
  
)

export default component.exports